import React, { useEffect, useState } from "react";
// import {useLocation} from "react-router-dom"
import Sidedrawer from "./co-components/Sidedrawer";
import AllChats from "./co-components/AllChats";
import Chatbox from "./co-components/Chatbox";
import "../CSS/ChatPage.css";
import { useNavigate } from "react-router-dom";
// import { display } from "@mui/system";

const ChatPage = () => {
  const [chats, setChats] = useState([]);
  const [userInfo, setUserInfo] = useState();
  const [selectedChat, setSelectedChat] = useState();
  const [openChat, setOpenChat] = useState();
  const [getChatsAgain, setGetChatsAgain] = useState();
  const [notification, setNotification] = useState();
  const [windowSize, setWindowSize] = useState(getWindowSize());
  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  const navigate = useNavigate();

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }
  // const location = useLocation();
  // console.log('location',location.state)

  useEffect(() => {
    getUserInfo();
    // getChats();
  }, []);
  const getUserInfo = async () => {
    const user = JSON.parse(localStorage.getItem("userInfo"));
    setUserInfo(user);
    if (!user) {
      // console.log("user1",user)
      navigate("/", {});
    }

    // if (user) {
    //   setUserInfo(user);
    // }
    // console.log("userInfo",userInfo)
  };
  const selectedChatHandler = (chatComing) => {
    // console.log("chatComingsssssss", chatComing);
    setSelectedChat(chatComing);
  };
  const getChats = (chatsComing) => {
    // console.log('coooo',chatsComing)
    setChats(chatsComing, ...chats);
  };
  const openChatHandler = (openThisChat) => {
    // console.log("openThisChat", openThisChat);
    setOpenChat(openThisChat);
  };
  // console.log("userInfo", userInfo);
  // console.log("notification2", notification);

  return (
    <div>
      <div style={{ width: "100%" }}>
        {userInfo && (
          <Sidedrawer
            userInfo={userInfo}
            chats={chats}
            selectedChatHandler={selectedChatHandler}
            // setChats={setChats}
            // notificationState={notification}
            // setNotificationState={setNotification}
            notification={notification}
            setNotification={setNotification}
            openChatHandler={openChatHandler}
          />
        )}
        <div className="chat_page">
          <div
            className="all_chats_side"
            style={{
              width: windowSize.innerWidth >= "850" ? "35%" : "100%",
              display: openChat && windowSize.innerWidth <= "850" ? "none" : "",
            }}
          >
            <div className="all_chats_container">
              {userInfo && (
                <AllChats
                  getChats={getChats}
                  userInfo={userInfo}
                  selectedChatHandler={selectedChatHandler}
                  selectedChat={selectedChat}
                  openChatHandler={openChatHandler}
                  getChatsAgain={getChatsAgain}
                  openChat={openChat}
                  // setGetChatsAgain={setGetChatsAgain}
                  // key={userInfo._id}
                />
              )}
            </div>
          </div>

          {/* ===Simple without responsiveness=== */}
          {/* <div className="all_chats_side">
            <div className="all_chats_container">
              {userInfo && (
                <AllChats
                  getChats={getChats}
                  userInfo={userInfo}
                  selectedChatHandler={selectedChatHandler}
                  selectedChat={selectedChat}
                />
              )}
            </div>
          </div> */}

          <div
            className="chat_box_container"
            style={{
              width: windowSize.innerWidth >= "850" ? "64%" : "100%",
              display:
                !openChat && windowSize.innerWidth <= "850" ? "none" : "",
            }}
          >
            {userInfo && (
              <Chatbox
                userInfo={userInfo}
                getChatsAgain={getChatsAgain}
                setGetChatsAgain={setGetChatsAgain}
                openChat={openChat}
                setOpenChat={setOpenChat}
                windowWidth={windowSize.innerWidth}
                notificationState={notification}
                setNotificationState={setNotification}
              />
            )}
          </div>
        </div>
      </div>
      {/* <div className="dev_name_conatiner">Nadeem</div> */}

      {/* <div>
        <h2>Width: {windowSize.innerWidth}</h2>

        <h2>Height: {windowSize.innerHeight}</h2>
      </div> */}
    </div>
  );
};

export default ChatPage;
